var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHamburgerIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 5H2v1.984h16zm0 4.382H2v1.984h16zM2 13.768h16v1.983H2z",
  clipRule: "evenodd"
})));
export { SvgHamburgerIcon as ReactComponent };
export default __webpack_public_path__ + "9d8b15f00246578f0ea8a40c54ffe062.svg";